
const digest = 'ab6a6ea80dc2de6d3f1d8223b698fcb9ae1e232fe4bbc0c08f913c9d7f17199d';
const classes = {"wrapper":"_wrapper_1a2e8_1","toggleButton":"_toggleButton_1a2e8_5","inputGroup":"_inputGroup_1a2e8_9","button":"_button_1a2e8_34","allowed":"_allowed_1a2e8_46"};
const css = `._wrapper_1a2e8_1 {
  flex: 1;
  margin-top: 10px;
}
._wrapper_1a2e8_1 ._toggleButton_1a2e8_5 {
  font-weight: 400;
}

._inputGroup_1a2e8_9 {
  height: auto !important;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  max-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 10px 0;
  color: #000;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 365px;
}
._inputGroup_1a2e8_9:focus-within {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._inputGroup_1a2e8_9 ._button_1a2e8_34 {
  display: flex;
  height: 55px;
  border-left: 1px #e2e5ed solid;
  padding: 15px 20px;
  font-weight: 500;
  border-top-right-radius: 24.5px;
  border-bottom-right-radius: 24.5px;
  align-items: center;
  color: #909090;
  cursor: not-allowed;
}
._inputGroup_1a2e8_9 ._allowed_1a2e8_46 {
  color: #1665d8;
  cursor: pointer;
}
._inputGroup_1a2e8_9 ._allowed_1a2e8_46:hover {
  background-color: #1665d8;
  color: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  